export default __webpack_public_path__ + "static/media/car2.b1cafdc5.jpeg";